import { RouterProvider } from "react-router-dom";
import Route from "./route";
import { ThemeProvider } from "@emotion/react";
import theme from "./theme";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();
function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={Route} />
        </QueryClientProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
